export const RECEIVE_ZONE = 'RECEIVE_ZONE';
export const SELECT_COMPANY = 'SELECT_COMPANY';
export const SELECT_ZONE = 'SELECT_ZONE';
export const SELECT_MASTER_GLOBAL = 'SELECT_MASTER_GLOBAL';

// Gestion des zones : création, renommage, suppression, affectation.
export const ZONE_MANAGE_GET = 'ZONE_MANAGE_GET';
export const ZONE_MANAGE_SUCCESS = 'ZONE_MANAGE_SUCCESS';
export const ZONE_CREATE = 'ZONE_CREATE';
export const ZONE_RENAME = 'ZONE_RENAME';
export const ZONE_DELETE = 'ZONE_DELETE';
export const ZONE_ASSIGN = 'ZONE_ASSIGN';
export const ZONE_COPY = 'ZONE_COPY';
